import { PaymentReceivedComponent } from './../payment-received/payment-received.component';
import { BillingDetailsComponent } from './billing-details/billing-details.component';
import { BankGridComponent } from './bank-grid/bank-grid.component';
import { Component, inject, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Item, ItemService } from './item-detail.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule, CurrencyPipe, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Location } from '@angular/common';
import { ImageCarouselComponent } from './image-carousel/image-carousel.component';
import { DomSanitizer, SafeHtml, SafeUrl, Title } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../shared/footer/footer.component';
import { CartQtyControlComponent, ICartItem } from '../cart-qty-control/cart-qty-control.component';
import { Dialog } from '@angular/cdk/dialog';
import { ProductGrid1Component } from '../grids/product-grid1/product-grid1.component';
import html2canvas from 'html2canvas-pro';
import { MatTooltipModule } from '@angular/material/tooltip';
import { APPHOST } from '../../app.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { CreatePaymentSessionRequest, CustomerInfo, CustomerInfoDialogReturn, IPaymentResponse, PayPlusService } from '../../payplus.service';
import { catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { RecaptchaModule, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-item-detail',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, RouterModule, YouTubePlayerModule,
    RecaptchaV3Module, RecaptchaModule, MatDialogModule,
    ProductGrid1Component, ImageCarouselComponent, FooterComponent, CartQtyControlComponent, MatIconModule, BankGridComponent],
  providers: [
    CurrencyPipe
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './item-detail.component.html',
  styleUrl: './item-detail.component.scss'
})
export class ItemDetailComponent {
  ID = '';
  product?: Item;
  images = new Set<string>();
  slug = ''
  showCompatibles: boolean = false;
  date = Date.now();

  isSS = false;
  kokoFullPrice: number = 0;
  kokoInstallmentPrice: number = 0;
  safePaykokoUrl: any;
  safePaykokoImgUrl: any;
  newCardPrice = 0;
  BANKS = {
    bank_transfer: ''
  }

  readonly matdialog = inject(MatDialog);

  // compatiblesService
  constructor(private itemService: ItemService,
    public dialog: Dialog, private recaptchaV3Service: ReCaptchaV3Service,
    private currencyPipe: CurrencyPipe,

    private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object,
    private payplusService: PayPlusService,
    private activatedRoure: ActivatedRoute,
    private meta: Meta, private titleService: Title, @Inject(DOCUMENT) private document: Document,
    private location: Location, private sanitizer: DomSanitizer,) {

    activatedRoure.queryParams.subscribe(w => {
      if (w['orderId']) {
        this.recaptchaV3Service.execute('importantAction')
          .subscribe((token) => {


            itemService.getQuotationBody(w['orderId']).subscribe(ew => {
              itemService.patchQuotation({ ...ew.body, orderStatus: 'PAID', paid: true }).subscribe(ee => {

                // alert('Thank You!\nPayment Received! will be in touch with you for your order')
                const d = this.matdialog.open(PaymentReceivedComponent, {
                  width: '500px',
                  height: '500px',

                  hasBackdrop: true,
                  disableClose: false

                });


              })

            })


          });

      }
      console.log(w);

    })


    this.route.data.subscribe(g => {
      this.product = g['item'] as Item
      if (this.product.newPrice! <= 10000) {
        this.newCardPrice = this.product.newPrice! + (this.product.newPrice! * 3.5 / 100);
      }
      // TODO: 3.5% added


      if (this.product.compatibleItems !== undefined && this.product.compatibleItems !== null) {
        this.showCompatibles = this.product.compatibleItems.length > 0;
      } else {
        this.showCompatibles = false;
      }
      this.kokoFullPrice = this.product.newPrice! * 1.13
      this.kokoInstallmentPrice = Number((this.kokoFullPrice / 3).toFixed(2))
      this.slug = this.product.slug + '_' + this.product.id
      this.images = new Set<string>();
      this.createImageSet()
      this.createMetaTag()

    })

    // this.paykokourl= 'https://paykoko.com/checkout?amount=' + this.kokoFullPrice + '&currency=LKR&description=' + this.product?.label + '&reference=' + this.product?.id + '&success_url=' + APPHOST + '/item/' + this.slug + '&cancel_url=' + APPHOST + '/item/' + this.slug;
    this.safePaykokoUrl = this.sanitizer.bypassSecurityTrustUrl('https://paykoko.com/')
    this.safePaykokoImgUrl = this.sanitizer.bypassSecurityTrustUrl('https://paykoko.com/img/logo1.7ff549c0.png')
  }

  createMetaTag() {


    try {
      this.meta.removeTag('title');
      this.meta.removeTag('description');

      this.meta.removeTag('og:type');
      this.meta.removeTag('og:url');
      this.meta.removeTag('og:title');
      this.meta.removeTag('og:description');
      this.meta.removeTag('og:image');


      this.meta.removeTag('twitter:card');
      this.meta.removeTag('twitter:url');
      this.meta.removeTag('twitter:title');
      this.meta.removeTag('twitter:description');
      this.meta.removeTag('twitter:image');
      this.meta.removeTag('twitter:image');
    } catch (error) {

    }


    // let domain = 'https://www.softnetcomputers.lk'
    // try {


    //   if (typeof window === "undefined") {
    //     domain = 'https://www.softnetcomputers.lk'
    //   } else {
    //     const full = location.protocol + '//' + location.host;

    //     if (full.includes('localhost') || full.includes('www')) {
    //       domain = 'https://www.softnetcomputers.lk'
    //     } else {
    //       domain = 'https://softnetcomputers.lk'
    //     }
    //   }
    // } catch (error) {

    // }

    var d1 = this.document.createElement('div')
    d1.innerHTML = this.product?.fullSpec!;

    this.titleService.setTitle(this.product?.label!)

    this.meta.addTag({ name: 'title', content: this.product?.label! });
    this.meta.addTag({ name: 'description', content: d1.textContent! });

    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: 'https://softnetcomputers.lk/' + this.product?.category?.slug + '/' + this.product?.slug + '_' + this.product?.id });
    this.meta.addTag({ property: 'og:title', content: this.product?.label! });
    this.meta.addTag({ name: 'og:description', content: d1.textContent! });
    this.meta.addTag({ name: 'og:image', content: encodeURI('http://softnetcomputers.lk' + '/' + this.product?.icon!) });
    this.meta.addTag({ name: 'og:image:secure', content: encodeURI('https://softnetcomputers.lk' + '/' + this.product?.icon!) });
    this.meta.addTag({ name: 'og:image:secure_url', content: encodeURI('https://softnetcomputers.lk' + '/' + this.product?.icon!) });


    this.meta.addTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.addTag({ property: 'twitter:url', content: 'https://softnetcomputers.lk/' + this.product?.category?.slug + '/' + this.product?.slug + '_' + this.product?.id });
    this.meta.addTag({ property: 'twitter:title', content: this.product?.label! });
    this.meta.addTag({ name: 'twitter:description', content: d1.textContent! });
    this.meta.addTag({ name: 'twitter:image', content: encodeURI('http://softnetcomputers.lk' + '/' + this.product?.icon!) });
    this.meta.addTag({ name: 'twitter:image:secure', content: encodeURI('https://softnetcomputers.lk' + '/' + this.product?.icon!) });


  }

  addToCart() {
    this.open();
  }
  createImageSet() {
    if (this.product!.image1)
      this.images.add(APPHOST + '/' + this.product!.image1!.replace('/image', '/image/thumb/600/1.0'))
    if (this.product!.image2)
      this.images.add(APPHOST + '/' + this.product!.image2!.replace('/image', '/image/thumb/600/1.0'))
    if (this.product!.image3)
      this.images.add(APPHOST + '/' + this.product!.image3!.replace('/image', '/image/thumb/600/1.0'))
    if (this.product!.image4)
      this.images.add(APPHOST + '/' + this.product!.image4!.replace('/image', '/image/thumb/600/1.0'))
    if (this.product!.image5)
      this.images.add(APPHOST + '/' + this.product!.image5!.replace('/image', '/image/thumb/600/1.0'))
    if (this.product!.image6)
      this.images.add(APPHOST + '/' + this.product!.image6!.replace('/image', '/image/thumb/600/1.0'))
  }

  // getImages(s: Set<string >): Set<string> {
  //   return new Set<string>(s)
  // }

  fullSpec(): SafeHtml {
    // a.replace(/;/g, '!important;')
    // line-height:1.25 !important; margin-bottom:2px !important;
    return this.sanitizer.bypassSecurityTrustHtml(this.product?.fullSpec!.replace(/;/g, '!important; ')!)
  }


  open() {

    this.dialog.open(CartQtyControlComponent, {
      width: '100vw',
      minHeight: '100%',
      height: '100vh',
      // minHeight: '100%',
      data: {
        product: this.product,
        images: this.images
      },
      hasBackdrop: true,
      disableClose: false

    });
  }

  goesWell(d?: Item[]): boolean {
    try {
      if (d === undefined) {
        return false
      }
      if (typeof d === undefined) {
        return false
      }
      if (d === null) {
        return false
      }

      if (d.length === 0) {
        return false
      }
      // console.log(d.length);
    } catch (error) {
      return false

    }


    return true;
  }
  downloadCanvasAsImage() {

    if (isPlatformBrowser(this.platformId)) {
      this.isSS = true
      const captureElement = document.getElementById('spec_sheet') as HTMLElement;
      setTimeout(() => {
        html2canvas(captureElement).then((canvas) => {
          const imageData = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.setAttribute("download", this.product?.label + " screenshot | softnetcomputers.lk .png");
          link.setAttribute("href", imageData);
          link.click();


        }).finally(() => {
          this.isSS = false
        });
      }, 100);



    }
  }


  purchaseNow() {


    const dialogRef = this.matdialog.open(BillingDetailsComponent, {
      width: '500px',
      // minHeight: '100%',
      height: '500px',
      // minHeight: '100%',

      hasBackdrop: true,
      disableClose: false

    });

    dialogRef.afterClosed().subscribe((_result: CustomerInfoDialogReturn) => {

      const result: CustomerInfo = {
        ..._result
      }
      console.log(result);

      if (!this.product || !this.newCardPrice) {
        console.error('Product data is missing. Cannot initiate payment.');
        return;
      }
      var dt = new Date();

      const year = dt.getFullYear();
      const month = (dt.getMonth() + 1).toString().padStart(2, "0");
      const day = dt.getDate().toString().padStart(2, "0");


      const orderId = 'ORD-' + year + month + day + dt.getHours().toString().padStart(2, "0") + '-' + this.makeRandomId(4);
      const amount = this.newCardPrice;




      this.recaptchaV3Service.execute('importantAction')
        .subscribe((token) => {
          var dt = new Date();

          const year = dt.getFullYear();
          const month = (dt.getMonth() + 1).toString().padStart(2, "0");
          const day = dt.getDate().toString().padStart(2, "0");

          const d = {
            "date": day + '-' + month + '-' + year,
            "itemsTotal": this.currencyPipe.transform(amount, 'Rs.')!,

            qid: orderId,
            "records": [
              {
                description: this.product?.label,
                quantity: _result.qty,
                productId: this.product?.id,
                warranty: this.product?.warranty,
                unitPrice: this.product?.newPrice,
                total: (this.product?.newPrice! * _result.qty!).toString(),
                icon: this.product?.icon


              } as ICartItem
            ]
          };

          this.itemService.postQuotation({
            "customerName": result.firstname + ' ' + result.lastname,
            "phoneNumber": result.dialCode + result.phoneNumber!,
            "email": result.email,
            "qid": orderId,
            "createdDate": this.getFormattedDate(),
            "pdf": JSON.stringify(d, null, 2),
            'total': (this.product?.newPrice! * _result.qty!).toString(),
            'requestType': 'ONLINE_ORDER',
            'markAsRead': false,
            'orderIsReady': false,
            'orderDelivered': false,
            'paid': false,
            'orderStatus': 'UNPAID'


          }, token).subscribe(w => {

            const description = this.product!.label + ' ' + this.product!.id;
            const redirectUrl = APPHOST + this.location.path() + '?orderStatus=SUCCESS&orderId=' + w.body.id;
            console.log(redirectUrl);

            const source = 'ANGULAR_JS';

            const paymentSessionRequest: CreatePaymentSessionRequest = {

              amount,
              orderId,
              redirectUrl,
              applicationKey: environment.payplus.applicationKey,
              domain: 'softnetcomputers.lk',
              source,
              description,
              paymentType: 'ONE_TIME',
              currency: 'LKR',
              platformType: 'WEB',
              customerInfo: result,

            };


            this.payplusService.createPaymentSession({ ...paymentSessionRequest })

              .subscribe({
                next: (res) => {

                  const link = res.body?.data.link;
                  const token = res.body?.data.token;
                  if (res.body?.data.link) {
                    window.open(link)
                  } else {

                  }
                },
                error: (e) => {

                }

              })


          });
        });
    });
  }

  getFormattedDate() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }
  makeRandomId = (length: number) => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  callNumber(num: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = `tel:${num}`;
    }
  }

}
